import { useState, useEffect } from "react";

import { useApi } from "@/shared/api";

export const useGetRandomQuote = ({ open }: { open: boolean }) => {
  const [randomQuote, setRandomQuote] = useState<{
    text: string;
    author: string;
  } | null>(null);

  const { api } = useApi({ version: "v2" });

  useEffect(() => {
    const quoteCount = 210;
    const randomQuoteIndex = Math.floor(Math.random() * quoteCount);

    const randomQuote = async () => {
      const { data } = await api.get("/quotes", {
        params: {
          currentPage: randomQuoteIndex,
          pageSize: 1,
        },
      });

      return data;
    };

    if (open === true) {
      randomQuote().then((quotes) => {
        if (quotes.data.length > 0) {
          const quote = quotes.data[0];
          setRandomQuote(quote);
        }
      });
    }
  }, [open, api]);

  return { randomQuote };
};
